import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { FinancialRecordsExplorer } from '@apps/web/components/financials/financial_records_explorer';
import { useOrganizationId } from '@apps/web/hooks/use_organization_id';
import { isOrganizationAdmin } from '@apps/web/lib/organization_permissions';
import { useUserProfile } from '@apps/web/swr_data_fetching/current_user_queries';
import { useOrganization } from '@apps/web/swr_data_fetching/organization_queries';

export const Route = createFileRoute('/_app/(main)/financials')({
    component: FinancialsRoute,
    head: () => ({
        meta: [
            {
                title: 'Financials | Phoebe',
            },
        ],
    }),
});

function FinancialsRoute() {
    const organizationId = useOrganizationId();
    const { data: userProfile } = useUserProfile({
        reason: 'financials-route-guard',
    });
    const { data: organization } = useOrganization(organizationId, {
        reason: 'financials-route-guard',
    });
    const navigate = useNavigate();
    // Mirrors the API gate: Phoebe admins always, org admins once the flag
    // is on.
    const allowed =
        userProfile?.user.admin === true ||
        (organization?.features?.['financials_enabled'] === true &&
            isOrganizationAdmin(userProfile, organizationId));
    const denied =
        userProfile !== undefined && organization !== undefined && !allowed;

    useEffect(() => {
        if (denied) {
            navigate({ to: '/', replace: true });
        }
    }, [denied, navigate]);

    if (!organizationId || !organization || !allowed) {
        return null;
    }

    return (
        <div className="p-6">
            <FinancialRecordsExplorer
                key={organizationId}
                organizationId={organizationId}
                name={organization.name}
                timezone={organization.timezone}
            />
        </div>
    );
}
